import React from 'react';
import { MatchDriverResponse } from '../../models/MatchDriverResponse';

interface DriverFoundNotificationProps {
  driverData: MatchDriverResponse;
  onConnect: () => void;
  onClose: () => void;
}

const DriverFoundNotification: React.FC<DriverFoundNotificationProps> = ({
  driverData,
  onConnect,
  onClose
}) => {
  return (
    <div className="driver-notification-inline">
      <div className="driver-notification-content">
        <div className="driver-notification-header">
          <span className="driver-notification-icon icon-search"></span>
          <h6 className="mb-1">Psst... We found your driver!</h6>
        </div>
        <div className="driver-notification-body">
          <p className="driver-notification-text mb-2">
            It looks like we found your driver: <strong>{driverData.firstName} {driverData.lastName}. </strong>
            If this is you, please click the button below to link your driver to your account.
          </p>
          
          <div className="driver-details">
            {driverData.lastRaceAt && (
              <div className="driver-detail-item">
                <span className="detail-label">Last Race At:</span> 
                <span className="detail-value">{new Date(driverData.lastRaceAt).toLocaleDateString()}</span>
              </div>
            )}
            
            {driverData.lastTrack && (
              <div className="driver-detail-item">
                <span className="detail-label">Last Track:</span> 
                <span className="detail-value">{driverData.lastTrack}</span>
              </div>
            )}
            
            {driverData.lastCar && (
              <div className="driver-detail-item">
                <span className="detail-label">Last Car:</span> 
                <span className="detail-value">{driverData.lastCar}</span>
              </div>
            )}
            
            {driverData.lastLocation && (
              <div className="driver-detail-item">
                <span className="detail-label">Location:</span> 
                <span className="detail-value">{driverData.lastLocation}</span>
              </div>
            )}
          </div>
        </div>
        <div className="driver-notification-actions">
          <button 
            className="btn btn-sm btn-primary me-2" 
            onClick={onConnect}
          >
            Link Driver 
          </button>
          <button 
            className="btn btn-sm btn-outline-light" 
            onClick={onClose}
          >
            Not My Driver
          </button>
        </div>
      </div>
    </div>
  );
};

export default DriverFoundNotification;

